const mEditionBillingProductDetail = {
  mEditionBillingProductDetail: {
    infoLeft: {
      autoresponders: {
        description: 'Discripcion:',
        list: 'Lista:',
        title: 'Autoresponders: '
      },
      discount_coupons: 'Cupones de descuento: ',
      free_trial: {
        frequency: 'Frecuencia: ',
        range: 'Intervalo: ',
        title: 'Tiene periodo de prueba gratuito'
      },
      pages: {
        external: 'Externo: ',
        gratitude_title: 'Paginas de agradecimiento: ',
        name: 'Nombre: ',
        type: 'Tipo: ',
        sales_title: 'Cartas de venta: '
      },
      projects: 'Los Proyectos incluidos',
      students: 'Ventas completadas y activas: ',
      tags: 'Etiquetas: ',
      title: 'DETALLES GENERALES',
      tracking_codes: 'Codigos de rastreo',
      discount_coupon: 'Codigos de descuento'
    },

    infoRight1: {
      title: 'Detalles de gestion ',
      pago: {
        true: 'El producto es de pago',
        false: 'El producto es gratuito'
      },
      payment_gateway: {
        description: 'Descripcion: ',
        name: 'Nombre: ',
        title: 'Medios de pago: '
      },
      plans: {
        title: 'Formas de pago: '
      },
      sell_point: 'Punto de venta: '
    },

    infoRight2: {
      title: 'Detalles de licencia'
    }
  }
}

export default mEditionBillingProductDetail
